"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidationErrors = exports.getValidationErrorMessages = exports.getValidationErrorMessage = exports.getErrorResponseData = exports.getErrorMessages = exports.getErrorMessage = void 0;
const getErrorResponseData = errorResponse => errorResponse && errorResponse.response && errorResponse.response.data !== undefined ? errorResponse.response.data : null;
exports.getErrorResponseData = getErrorResponseData;
const getErrorMessage = errorResponse => getErrorResponseData(errorResponse) && getErrorResponseData(errorResponse).message !== undefined ? getErrorResponseData(errorResponse).message : null;
exports.getErrorMessage = getErrorMessage;
const getValidationErrors = errorResponse => getErrorResponseData(errorResponse) && getErrorResponseData(errorResponse).errors !== undefined ? getErrorResponseData(errorResponse).errors : null;
exports.getValidationErrors = getValidationErrors;
const getValidationErrorMessage = (errorResponse, fieldName) => getValidationErrors(errorResponse) && getValidationErrors(errorResponse)[fieldName] !== undefined ? getValidationErrors(errorResponse)[fieldName] : null;
exports.getValidationErrorMessage = getValidationErrorMessage;
const getValidationErrorMessages = errorResponse => getValidationErrors(errorResponse) ? Object.values(getValidationErrors(errorResponse)) : [];
exports.getValidationErrorMessages = getValidationErrorMessages;
const getErrorMessages = errorResponse => {
  const errorMessage = getErrorMessage(errorResponse);
  const validationErrorMessages = getValidationErrorMessages(errorResponse) || [];
  return [errorMessage, ...validationErrorMessages];
};
exports.getErrorMessages = getErrorMessages;